import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/dagngfptto0ceqqni10g";

export default function Footer() {
  const [status, setStatus] = useState<{ type: "idle" | "ok" | "err"; msg: string }>({ type: "idle", msg: "" });
  const [sending, setSending] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = (fd.get("contact_alt") as string) || "";
    if (honeypot.trim()) {
      setStatus({ type: "ok", msg: "订阅成功，关注追更吧！" });
      form.reset();
      return;
    }

    const email = (fd.get("email") as string) || "";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus({ type: "err", msg: "请输入正确的邮箱地址。" });
      return;
    }

    setSending(true);
    setStatus({ type: "idle", msg: "" });
    try {
      const payload = new URLSearchParams();
      payload.set("email", email);
      const resp = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const text = await resp.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      if (resp.ok && parsed?.code === "OK") {
        setStatus({ type: "ok", msg: "订阅成功！新瓜反转第一时间推送给你。" });
        form.reset();
      } else if (String(serverMsg).toLowerCase().includes("spam")) {
        setStatus({ type: "err", msg: serverMsg || "提交未成功，请稍后再试。" });
      } else {
        setStatus({ type: "err", msg: serverMsg || "提交失败，请稍后再试。" });
      }
    } catch {
      setStatus({ type: "err", msg: "网络异常，请稍后再试。" });
    } finally {
      setSending(false);
    }
  }

  return (
    <footer className="border-t border-background-200 bg-accent-100/40">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid gap-10 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-eye-2-line text-xl"></i>
              </span>
              <span className="heading-font text-xl text-primary-600">每日看瓜</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-7 text-foreground-700">
              聚合娱乐、职场、社会、生活与科技等热门事件瓜田现场，为吃瓜群众提供前排围观、
              蹲后续进度与神反转速递。看热闹不迷路，每天准时开瓜。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["#吃瓜现场", "#蹲后续", "#神评论", "#反转细节"].map((t) => (
                <span key={t} className="rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-600">
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-bold text-foreground-900">快速导航</h3>
            <ul className="grid gap-2.5 text-sm">
              {[
                { t: "今日瓜榜", h: "#gubang" },
                { t: "瓜田速递", h: "#guatian" },
                { t: "蹲后续", h: "#gensui" },
                { t: "神评墙", h: "#shenping" },
                { t: "吃瓜指南", h: "#guide" },
              ].map((i) => (
                <li key={i.h}>
                  <a href={i.h} className="text-foreground-600 hover:text-primary-600">
                    {i.t}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-bold text-foreground-900">追更订阅</h3>
            <p className="mb-4 text-sm text-foreground-600">订阅后第一时间收到新瓜与反转提醒。</p>
            <form onSubmit={handleSubmit} data-readdy-form className="grid gap-2.5">
              <div className="flex flex-col gap-2 sm:flex-row">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="输入你的邮箱"
                  className="w-full rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
                <button
                  type="submit"
                  disabled={sending}
                  className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
                >
                  {sending ? "发送中…" : "订阅"}
                </button>
              </div>
              <div className="hp-trap" aria-hidden="true">
                <input
                  type="text"
                  name="contact_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  readOnly
                  aria-hidden="true"
                />
              </div>
              {status.msg && (
                <p
                  className={`text-xs ${
                    status.type === "ok" ? "text-accent-700" : "text-primary-700"
                  }`}
                >
                  {status.msg}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 每日看瓜 · 仅供内容演示的娱乐社区 · 联系：hi@meirikangua.com
          </p>
          <p className="text-xs text-foreground-500">前排吃瓜 · 理性围观 · 不造谣不传谣</p>
        </div>
      </div>
    </footer>
  );
}